export default __webpack_public_path__ + "static/media/merged_area_icon.6e3193b2.svg";